import { create } from "zustand";
export const useRouterStore = create((set) => ({
    navigate: null,
    location: null,
    setRouter: (router) => set({ ...router }),
}));
